<template>
  <div class="upload">
    <BaseListPage
        :name="name"
        :store-path="storePath"
        :no-condition="false"
        :table-set-list="tableSetList"
        :table-data-list="sortedList"
        :show-search-component="false"
        :show-custom-search-component="true"
        title="アップロード"
        title-class="upload-header"
        icon="upload">
      <span
          slot="message"
          class="headerMessage">
        注文修正禁止時間帯：10:00-10:15、22:00-22:15<br>
        公開数一括登録禁止時間帯：22:30-23:15
      </span>
      <UploadConditionModal
          slot="customSearchComponent"
          :store-path="storePath"
          :res-path="responsePath"
          :save-key="saveKey"
          @getLatest="onGetLatest" />
    </BaseListPage>
  </div>
</template>
<style>
.headerMessage {
  color: red;
}

.upload tr:hover td {
  background-color: initial !important;
}
</style>
<script>
// import Vue from 'vue'
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'
import * as define from '@/define'
import * as query from '@/queries/upload'
import common from '@/utils/common'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import * as config from '@/config'
import message from '@/utils/message'

import x from '@/components/mixins/mixin'
import BaseListPage from '@/components/organisms/BaseListPage'
import UploadConditionModal from '@/components/pages/upload_download/upload/UploadConditionModal'

const STATUS = Object.freeze({
  PROCESSING: 0,
  COMPLETE: 1,
  TIMEOUT: 6,
  IMPORTERROR: 7,
  CHECKERROR: 8,
  ERROR: 9
})

let timer = null

export default {
  name: 'UploadTop',
  components: {
    BaseListPage,
    UploadConditionModal
  },
  mixins: [x],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      componentKey: 0
    }
  },
  computed: {
    define: () => define,
    ...mapGetters({
      getSortedList: 'sortedList'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    ...mapState({
      tdLists: (state) => state.Upload.tdLists
    }),
    name () {
      return 'uploadTop'
    },
    storePath () {
      return 'Upload'
    },
    saveKey () {
      return 'uploadCondition'
    },
    responsePath () {
      return 'data.accounts'
    },
    linkKey () {
      return 'uuid'
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    tableSetList () {
      return [
        { type: 'String', label: 'ファイル種類', path: 'templateDisplayValue', sortable: 'custom', width: 400 },
        { type: 'Date', label: 'リクエスト日時', path: 'createdAt', sortable: 'custom', width: 200 },
        { type: 'String', label: 'ステータス', path: this.rowStatus, elementType: ELEMENT_TYPE.FUNCTION,
          sortable: 'custom' },
        { type: 'String', label: '', path: this.downloadLink, elementType: ELEMENT_TYPE.LINK,
          onLinkClick: this.linkClick, class: 'visitedlinkNoChangeColor' }
      ]
    }
  },
  watch: {
    tdLists: {
      handler: function (val, oldVal) {
        // 再描画
        this.componentKey += 1
      },
      deep: true
    }
  },
  async created () {
    this.$loadingService.show()
    try {
      // 一覧とページを初期化
      const tdLists = this.storePath + '/tdLists'
      const currentPage = this.storePath + '/currentPage'
      this.$store.dispatch({
        type: 'set',
        states: {
          [tdLists]: [],
          [currentPage]: 0
        }
      })
      // 一覧情報取得
      await this.getUploadControlData()
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  beforeRouteLeave (to, from, next) {
    // 非同期処理の初期化
    if (timer) {
      clearInterval(timer)
      timer = null
    }

    next()
  },
  methods: {
    async linkClick (displayItem) {
      this.$loadingService.show()
      try {
        // ダウンロード用署名付きURL取得
        const url = config.GET_DOWNLOAD_URL + '/' + displayItem.uuid + '/' + '2'
        const method = 'get'
        const response = await common.apiAxios(url, { method })

        const downloadLink = this.downloadLink
        // リクエスト先URL
        const request = new XMLHttpRequest()
        request.open('GET', response.data.URL, true)
        request.responseType = 'blob'

        request.onload = function () {
          if (request.status !== 200) {
            // 失敗
            this.$notify.error(message.MSG_527())
          } else {
            // ダウンロード処理
            // request.responseTextではなく
            common.fileDownload(request.response, request.responseType, downloadLink(displayItem))
          }
        }
        request.send(null)
      } catch (error) {
        common.addError(error, { msg: message.MSG_527() })
        this.$notify.error({ error: error })
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    downloadLink: function (row) {
      if ((row.statusCode !== STATUS.PROCESSING) && row.filePath) {
        const filePathArray = row.filePath.split('/')
        return filePathArray[filePathArray.length - 1]
      }
      return ''
    },
    rowStatus: function (row) {
      switch (row.statusCode) {
        case STATUS.PROCESSING: return '処理中'
        case STATUS.COMPLETE: return 'アップロード完了'
        case STATUS.TIMEOUT: return 'タイムアウト'
        case STATUS.IMPORTERROR: return '取り込み処理エラーあり　結果ファイルをダウンロードし、アップロードしてください。'
        case STATUS.CHECKERROR: return 'チェックエラーあり　元ファイルの対象部分を修正して再度アップロードしてください。'
        case STATUS.ERROR: return '予期せぬエラー　管理者にご連絡ください。'
      }
      return ''
    },
    async getUploadControlData () {
      // 非同期処理の初期化
      if (timer) {
        clearInterval(timer)
        timer = null
      }
      const tdLists = this.storePath + '/tdLists'
      const currentPage = this.storePath + '/currentPage'
      const res = await common.postGraphQl(query.GRAPH_QL_QUERY_UPLOAD_CONTROLS)
      const resValue = common.getValueByPath(res.data, 'data.uploadControl')
      this.$store.dispatch({
        type: 'set',
        states: {
          [ tdLists ]: resValue,
          [ currentPage ]: 0
        }
      })
      if (resValue.some((data) => { return data.statusCode === STATUS.PROCESSING })) {
        timer = setInterval(() => {
          this.getLatestData()
          if (!resValue.some((data) => { return data.statusCode === STATUS.PROCESSING })) {
            clearInterval(timer)
            timer = null
          }
        }, 5000)
      }
      return res
    },
    async getLatestData () {
      await Promise.all(this.tdLists.filter((data) => { return data.statusCode === STATUS.PROCESSING })
        .map(async (data, index) => {
          const sql = common.addGraphQlCondition(query.GRAPH_QL_QUERY_UPLOAD_CONTROL, { uuid: data.uuid })
          const res = await common.postGraphQl(sql)

          const resValue = common.getValueByPath(res.data, 'data.uploadControl')
          if (resValue[0] && resValue[0].statusCode !== STATUS.PROCESSING) {
            const tdLists = this.storePath + '/tdLists'
            let newTdLists = _.cloneDeep(this.tdLists)
            newTdLists.some((data) => {
              if (data.uuid === resValue[0].uuid) {
                data.statusCode = resValue[0].statusCode
                data.filePath = resValue[0].filePath
                return true
              }
              return false
            })
            this.$store.dispatch({
              type: 'set',
              states: {
                [ tdLists ]: newTdLists
              }
            })
          }
        }))
    },
    async onGetLatest () {
      this.$loadingService.show()
      try {
      // 一覧情報取得
        await this.getUploadControlData()
      } catch (error) {
        this.$notify.error({ error: error })
        throw error
      } finally {
        this.$loadingService.close()
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/pages/upload_download/upload/UploadTop.vue